import { SimstanceManager } from "./simstance/SimstanceManager.js";
import { SimOption } from "./SimOption.js";
import { IntentManager } from "./intent/IntentManager.js";
import { RouterManager } from "./route/RouterManager.js";
import { Intent } from "./intent/Intent.js";
import { SimNoSuch } from "./throwable/SimNoSuch.js";
import { containers, Sim } from "./decorators/SimDecorator.js";
import { CacheManager } from "./cache/index.js";
import { ApiService } from "./fetch/index.js";
import { AlertFactory, AlertService, DefaultAlertFactory } from "./alert/index.js";
class SimpleApplication {
  // public rootRouter?: ConstructorType<any>;
  // constructor();
  // constructor(option: SimOption);
  // constructor(rootRouter?: ConstructorType<Object> | Function);
  // constructor(rootRouter?: ConstructorType<Object> | Function, option?: SimOption);
  // constructor(rootRouter?: (ConstructorType<Object> | Function) | SimOption, option = new SimOption()) {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  // private alertService: AlertService<any>;
  constructor(option = new SimOption()) {
    this.option = option;
    this.simstanceManager = new SimstanceManager(this, option);
    this.simstanceManager.setStoreSet(SimstanceManager, this.simstanceManager);
    this.routerManager = new RouterManager(this, this.simstanceManager, option);
    this.intentManager = new IntentManager(this, this.simstanceManager, this.routerManager, option);
    this.cacheManager = new CacheManager(this);
    if (!this.simstanceManager.getStoreSet(AlertFactory)) {
      this.simstanceManager.setStoreSet(AlertFactory, new DefaultAlertFactory());
    }
    Sim({ container: this.option.container })(AlertService);
    Sim({ container: this.option.container })(ApiService);
    this.simstanceManager.setStoreSet(IntentManager, this.intentManager);
    this.simstanceManager.setStoreSet(RouterManager, this.routerManager);
    this.simstanceManager.setStoreSet(CacheManager, this.cacheManager);
    containers.add(this);
  }
  getSimstanceManager() {
    return this.simstanceManager;
  }
  getIntentManager() {
    return this.intentManager;
  }
  getRouterManager() {
    return this.routerManager;
  }
  run(otherInstanceSim) {
    otherInstanceSim ??= /* @__PURE__ */ new Map();
    otherInstanceSim.set(SimpleApplication, this);
    this.simstanceManager.run(otherInstanceSim);
    return this;
  }
  simAtomic(type) {
    if (typeof type === "symbol") {
      return this.simstanceManager.findFirstSim(type);
    } else if (typeof type === "function") {
      return this.simstanceManager.findFirstSim({ type });
    }
  }
  simAtomics(type) {
    if (typeof type === "symbol") {
      return this.simstanceManager.findSims(type) ?? [];
    } else if (typeof type === "function") {
      return this.simstanceManager.findSims({ type }) ?? [];
    } else {
      return [];
    }
  }
  getInstance(type) {
    const i = this.sim(type);
    if (i) {
      return i;
    } else {
      throw new SimNoSuch("SimNoSuch: no simple instance(getInstance) name:" + type?.prototype?.constructor?.name + "," + type);
    }
  }
  sim(type) {
    return this.simAtomic(type)?.getValue();
  }
  sims(type) {
    return this.simAtomics(type).map((it) => it.getValue());
  }
  addSim(configOrTarget, target) {
    const r = Sim(configOrTarget);
    if (typeof r === "function" && target) {
      r(target);
    }
  }
  publishIntent(i, data) {
    return this.intentManager.publish(i, data);
  }
  routing(i, option) {
    if (i instanceof Intent) {
      return this.routerManager.routing(i, option);
    } else if (typeof i === "string") {
      const intent = new Intent(i);
      return this.routerManager.routing(intent, option);
    } else {
      const intent = new Intent(i.path, i.data);
      return this.routerManager.routing(intent, option);
    }
  }
}
export {
  SimpleApplication
};
//# sourceMappingURL=SimpleApplication.js.map
